module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-03-b664be113ee16a61aaad120fe2f78af7.png";